module.exports = __webpack_public_path__ + "img/duoduo.b97cba51.png";